import { render, staticRenderFns } from "./ModalBulkChangeStatus.vue?vue&type=template&id=138fbc8e&"
import script from "./ModalBulkChangeStatus.vue?vue&type=script&lang=js&"
export * from "./ModalBulkChangeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports